import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import style from "../../assets/jss/disal-main/components/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Grid from "@material-ui/core/Grid";
import Fade from "@material-ui/core/Fade";
import Modal from "@material-ui/core/Modal";
import api from "../../Services/ApiURLBase";
import { URLIngresoSpecficId } from "../../other/apis";

const useStyles = makeStyles(style);

const ModalIngres = props => {
  const classes = useStyles();
  const [subTypes, setSubTypes] = useState([]);

  const { data, onClose } = props;

  const fetchIngresos = async () => {
    try {
      const response = await api.get(URLIngresoSpecficId(data.inputId));
      setSubTypes(response.data.result.subTypes);
    } catch (error) {
      console.error('Error fetching ingresos:', error);
    }
  };

  useEffect(() => {
    fetchIngresos();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={true}
      onClose={() => onClose()}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500
      }}
    >
      <Fade in={true}>
        <div className={classes.modalIngreso}>
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className={classes.modalTitle} id="exampleModalLabel">
                  <span>Detalle de ingreso de residuos</span>
                </h5>
                <button className="btn-close" onClick={() => onClose()}>
                  <span className="closeSpan big"></span>
                </button>
              </div>
              <div className="modal-body ">
                <Grid container>
                  <Grid item xs={3}>
                    <label>
                        <strong>Planta</strong>
                    </label>
                    <p>{data.miningSiteName}</p>
                  </Grid>
                  <Grid item xs={3}>
                    <label>
                        <strong>Patio</strong>
                    </label>
                    <p>{data.warehouseName}</p>
                  </Grid>
                  <Grid item xs={3}>
                    <label>
                        <strong>Vehículo</strong>
                    </label>
                    <p>{data.vehiclePlateNumber}</p>
                  </Grid>
                  <Grid item xs={3}>
                    <label>
                        <strong>Ingreso</strong>
                    </label>
                    <p>{data.inputDate} {data.inputHour}</p>
                  </Grid>
                </Grid>
                <Grid container style={{ marginTop: "25px" }}>
                  <h4>
                    <span>Detalle de residuos</span>
                  </h4>
                </Grid>
                <Grid container style={{ marginTop: "25px" }}>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", alignItems: "center", gap: "10px" }}>
                    {subTypes.map(res => {
                      return (
                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                          <div
                            className="circle-ingreso"
                            style={{
                              backgroundColor: res.color,
                              border: res.name === "Plásticos" ? "1px solid #6A6A6A" : "none"
                            }}
                          ></div>
                          <div 
                            className="mb-0 text-residuo"
                            style={{
                              minWidth: "140px",
                            }}
                          >
                            {res.name}
                          </div>
                          <div 
                            className="mb-0"
                            style={{
                              minWidth: "80px",
                            }}
                          >
                            {(parseFloat(res.amount) / 1000).toFixed(2)} T
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </Grid>
                <Grid container style={{ marginTop: "25px" }}>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", alignItems: "center", gap: "10px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <strong style={{ width: "170px"}}>Total:</strong>
                      <strong style={{ width: "80px"}}>{(parseFloat(data.totalKG) / 1000).toFixed(2)} T</strong>
                    </div>
                  </div>
                </Grid>
              </div>
            </div>
          </div>
        </div>
      </Fade>
    </Modal>
  );
}

export default ModalIngres;
